import { SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN } from "@faire/web-api--source/indigofair/data/IUserMilestone/RetailerMilestone/SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { useRetailerMilestone } from "@faire/web/common/hooks";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useShopifyNewRetailerBenefitsGate: IGateHook = () => {
  const modalType = useModalType();
  const { hasOccurred: hasSeenShopifyOnboardingBenefitsModal } =
    useRetailerMilestone(SHOPIFY_ONBOARDING_BENEFITS_MODAL_SEEN);

  if (
    !hasSeenShopifyOnboardingBenefitsModal &&
    modalType === PromoModalType.SHOPIFY_NEW_RETAILER_BENEFITS_MODAL
  ) {
    return PromoModalType.SHOPIFY_NEW_RETAILER_BENEFITS_MODAL;
  }

  return undefined;
};
